export default __webpack_public_path__ + "static/image-03-480x298-9a9afcb603700b669e602b00a230359c.jpg";